<template>
    <BasePage :loading="loading" :error="error" :params="params" style="overflow: hidden">
        <SotHeader label="Выбери свой тариф" />
        <div class="q-pa-md base-page-content" style="padding-top: 35px">
            <div v-show="!loading" class="column" style="margin-bottom: 10px">
                <div class="text-subtitle1 q-pa-sm text-center" style="padding-bottom: 30px">Выбери свой тариф и возможность сэкономить до 100%</div>
                <div class="column q-gutter-y-md text-subtitle1">
                    <div v-for="(tariff, i) in tariffs" :key="i" class="row q-gutter-x-sm items-center">
                        <!---<q-radio v-model="activeTariff" :val="tariff" v-html="tariff.description" />-->
                        <div class="row items-center q-gutter-x-sm no-wrap">
                            <q-radio v-model="activeTariff" :val="tariff" />
                            <div v-html="tariff.description" class="cursor-pointer" @click="activeTariff = tariff"></div>
                        </div>
                    </div>
                    <div class="flex flex-center">
                        <DefaultButton label="Оплатить" @click="pay" style="width: 200px" />
                    </div>
                </div>
                <div style="height: 80px" class="relative-position row items-center">
                    <img src="new-icons/gosuslugi.png" style="width: 160px; object-fit: cover; background-color: white; z-index: 1" />
                    <q-separator color="primary" style="position: absolute; left: 0; top: 40px; width: 100%" />
                </div>
                <div class="text-subtitle1 text-center" style="padding-bottom: 30px">
                    <div>Специальное предложение</div>
                    <div>Количество ограничено</div>
                </div>
                <div class="column q-gutter-y-md text-subtitle1">
                    <div v-for="(tariff, i) in extraTariffs" :key="i" class="row q-gutter-x-sm items-center">
                        <div class="row items-center q-gutter-x-sm no-wrap">
                            <q-radio v-model="activeExtraTariff" :val="tariff" />
                            <div v-html="tariff.description" class="cursor-pointer" @click="activeExtraTariff = tariff"></div>
                        </div>
                    </div>
                    <div class="flex flex-center">
                        <DefaultButton label="Оставить заявку" @click="submitApplication" style="width: 200px" />
                    </div>
                </div>
            </div>
            <!--
            <div class="q-gutter-y-lg" style="margin-bottom: 0" v-show="!loading">
                <div>
                    <div>Курс</div>
                    <div class="text-weight-bold ellipsis-3-lines">{{ courseTitle }}</div>
                </div>
                <div>
                    <div>К оплате</div>
                    <div class="text-weight-bold">{{ tariff.price }} ₽</div>
                </div>
                <div>
                    <div>Ваш баланс:</div>
                    <div class="text-weight-bold">{{ balance }} ₽</div>
                </div>
                <div>Выберите способ оплаты</div>
                <div class="q-gutter-sm">
                    <DefaultButton label="Личный счет в Клубе СОТ" @click="payFromBalance" :loading="saving" />
                    <DefaultButton label="Банковская карта" @click="payFromCard" />
                </div>
            </div>
            -->
        </div>
    </BasePage>
</template>

<script>
import BasePage from 'pages/BasePage';
import SotHeader from 'components/ui/design/SotHeader';
import pageBuyCourseMixin from 'src/mixins/pageBuyCourseMixin';
import DefaultButton from 'components/ui/common/DefaultButton';

export default {
    name: 'PageBuyCourse',
    components: { DefaultButton, SotHeader, BasePage },
    mixins: [pageBuyCourseMixin],
    props: {
        params: {
            type: Object,
            default: undefined,
        },
    },
    data () {
        return {
            loading: false,
            saving: false,
            error: undefined,
            balance: 0,
        };
    },
    computed: {
        courseId () {
            return this.params.params.course_id;
        },
        courseTitle () {
            return this.params.course_title;
        },
    },
    mounted () {
        this.load();
    },
    methods: {
        pay () {
            // Оплатить
            if (!this.activeTariff) {
                this.$q.notify('Выберите тариф');
                return;
            }
            this.$pages.push({
                to: 'pay-course', title: this.courseTitle, course_id: this.courseId,
            });
        },
        submitApplication () {
            // Оставить заявку
            if (!this.activeExtraTariff) {
                this.$q.notify('Выберите специальное предложение');
                return;
            }
            const { externalCourseId } = this.course;
            const url = `https://www.gosuslugi.ru/600314/1/form?courseID=${externalCourseId}`;
            window.open(url, '_blank');
        },
        /*
        payFromBalance () {
            if (+this.balance < +this.tariff.price) {
                this.$q.notify('Недостаточно средств для оплаты курса');
                return;
            }
            this.$q.dialog({
                title: 'Подтверждение',
                message: `Вы хотите купить этот курс и оплатить его с баланса Вашего личного счета в Клубе СОТ? <br/><br/>Будет списана сумма: <b>${this.tariff.price} ₽</b>`,
                html: true,
                persistent: true,
                ok: {
                    label: 'Купить',
                    color: 'primary',
                },
                cancel: {
                    label: 'Отмена',
                    flat: true,
                },
            }).onOk(() => {
                this.saving = true;
                this.$db.users.buyCourse(this.tariff.price, this.courseId, this.courseTitle, this.tariff).then((result) => {
                    this.saving = false;
                    if (result) {
                        const hint = 'Теперь Вы можете пройти этот курс в любое удобное для Вас время';
                        this.$pages.push({
                            to: 'buy-success', title: this.courseTitle, product_type: 1, product_id: this.courseId, hint,
                        });
                    }
                });
            });
        },
        payFromCard () {
            this.$q.notify('TODO: Перейти на страницу оплаты картой');
        },
        */
    },
};
</script>

<style scoped>

</style>
